export const SEGMENTS = "SET_SEGMENTS";

export const setSegments = (segments) => {
	return {
		type: SEGMENTS,
		segments,
	};
};
